// Copyright 2026 Mo-Sys Engineering Ltd. All Rights Reserved.

// In development environment variables are set in .env file
// In production the URL is determined by the environment variable in public/env.js, which is injected at runtime ( see .gitlab-ci.yml )
export const ENV = {
  USE_LOCAL_ACCOUNTS: (window.env?.USE_LOCAL_ACCOUNTS ?? process.env.USE_LOCAL_ACCOUNTS) === 'true',

  REACT_APP_API_URL:
    process.env.NODE_ENV === 'development'
      ? process.env.REACT_APP_API_URL
      : window.env?.REACT_APP_API_URL,
  REACT_APP_WEBSOCKET_URL:
    process.env.NODE_ENV === 'development'
      ? process.env.REACT_APP_WEBSOCKET_URL
      : window.env?.REACT_APP_WEBSOCKET_URL,
  BASE_WEBRTC_STREAM_URL:
    process.env.NODE_ENV === 'development'
      ? process.env.BASE_WEBRTC_STREAM_URL
      : window.env?.BASE_WEBRTC_STREAM_URL,
};
